import { render, staticRenderFns } from "./PedidoDeCompraAprovacaoCompradorView.vue?vue&type=template&id=3111f2dc&scoped=true"
import script from "./PedidoDeCompraAprovacaoCompradorView.vue?vue&type=script&setup=true&lang=js"
export * from "./PedidoDeCompraAprovacaoCompradorView.vue?vue&type=script&setup=true&lang=js"
import style0 from "./PedidoDeCompraAprovacaoCompradorView.vue?vue&type=style&index=0&id=3111f2dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3111f2dc",
  null
  
)

export default component.exports